(() => {
  const HOTSPOT_POSITIONS = [
    { x: 58, y: 18 },
    { x: 33, y: 53 },
    { x: 44, y: 76 },
    { x: 72, y: 60 },
  ];

  const escapeHTML = (value = '') =>
    String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  function accountHref() {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/?$/, '/')}account`;
  }

  function fixHeaderAccountIcons(scope = document) {
    const wrappers = scope.querySelectorAll?.('#header-component .account-button') || [];

    wrappers.forEach((wrapper) => {
      const component = wrapper.querySelector('shopify-account');
      if (!component) return;

      let link = wrapper.querySelector('.devui-account-link');
      if (!link) {
        link = document.createElement('a');
        link.className = 'devui-account-link';
        link.href = accountHref();
        link.setAttribute('aria-label', 'Account');
        link.innerHTML = `
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <circle cx="12" cy="8" r="3.5" fill="none" stroke="currentColor" stroke-width="1.6"></circle>
            <path d="M5.5 20c.45-4.15 2.85-6.3 6.5-6.3s6.05 2.15 6.5 6.3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path>
          </svg>`;
        wrapper.appendChild(link);
      }

      wrapper.dataset.devuiAccountFixed = 'true';
      component.setAttribute('aria-hidden', 'true');
    });
  }

  function extractProducts(root) {
    const bestSection = root.querySelector('.ivalo-ed__banner + .ivalo-ed__products:not(.ivalo-ed__products--compact)');
    const sourceCards = bestSection
      ? Array.from(bestSection.querySelectorAll('.ivalo-ed__product-card'))
      : Array.from(root.querySelectorAll('.ivalo-ed__product-card'));

    const products = sourceCards.slice(0, 4).map((card) => {
      const link = card.querySelector('.ivalo-ed__product-title') || card.querySelector('.ivalo-ed__product-image');
      const image = card.querySelector('.ivalo-ed__product-image img');
      const price = card.querySelector('.ivalo-ed__product-price') || card.querySelector('.ivalo-ed__price');

      return {
        title: link?.textContent?.trim() || image?.alt || 'Ivalo Baby',
        href: link?.href || card.querySelector('a')?.href || '#',
        image: image?.currentSrc || image?.src || '',
        imageAlt: image?.alt || link?.textContent?.trim() || 'Ivalo Baby product',
        price: price?.textContent?.trim() || '',
      };
    });

    return products.filter((product) => product.href && product.image);
  }

  function hotspotCardHTML(product) {
    return `
      <div class="devui-hotspot-card__image">
        <img src="${escapeHTML(product.image)}" alt="${escapeHTML(product.imageAlt)}" loading="lazy" decoding="async">
      </div>
      <div class="devui-hotspot-card__title">${escapeHTML(product.title)}</div>
      <div class="devui-hotspot-card__rating" aria-label="Five star featured product">
        <span class="devui-hotspot-card__stars" aria-hidden="true">★★★★★</span>
      </div>
      ${product.price ? `<div class="devui-hotspot-card__price">${escapeHTML(product.price)}</div>` : ''}
      <a class="devui-hotspot-card__link" href="${escapeHTML(product.href)}">View Details</a>
    `;
  }

  function initHotspotShowcase(root) {
    const feature = root.querySelector('.ivalo-ed__feature');
    if (!feature || feature.dataset.devuiHotspotsReady === 'true') return;

    let products = extractProducts(root);
    if (!products.length) return;

    while (products.length < 4) products = products.concat(products);
    products = products.slice(0, 4);

    feature.dataset.devuiHotspotsReady = 'true';
    feature.classList.add('devui-hotspot-showcase');

    const points = document.createElement('div');
    points.className = 'devui-hotspot-points';
    points.setAttribute('aria-label', 'Featured products on image');

    const ui = document.createElement('div');
    ui.className = 'devui-hotspot-ui';
    ui.innerHTML = `
      <aside class="devui-hotspot-card" aria-live="polite"></aside>
      <div class="devui-hotspot-nav" aria-label="Featured product navigation">
        <button type="button" data-devui-hotspot-prev aria-label="Previous hotspot">‹</button>
        <button type="button" data-devui-hotspot-next aria-label="Next hotspot">›</button>
      </div>
    `;

    products.forEach((product, index) => {
      const position = HOTSPOT_POSITIONS[index] || HOTSPOT_POSITIONS[0];
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'devui-hotspot-dot';
      button.style.setProperty('--dot-x', `${position.x}%`);
      button.style.setProperty('--dot-y', `${position.y}%`);
      button.dataset.hotspotIndex = String(index);
      button.setAttribute('aria-label', `Show ${product.title}`);
      button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
      points.appendChild(button);
    });

    feature.append(points, ui);

    const card = ui.querySelector('.devui-hotspot-card');
    const dots = Array.from(points.querySelectorAll('.devui-hotspot-dot'));
    let active = 0;

    const setActive = (nextIndex) => {
      active = (nextIndex + products.length) % products.length;
      dots.forEach((dot, index) => {
        const selected = index === active;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      if (card) card.innerHTML = hotspotCardHTML(products[active]);
    };

    dots.forEach((dot, index) => dot.addEventListener('click', () => setActive(index)));
    ui.querySelector('[data-devui-hotspot-prev]')?.addEventListener('click', () => setActive(active - 1));
    ui.querySelector('[data-devui-hotspot-next]')?.addEventListener('click', () => setActive(active + 1));

    setActive(0);
  }

  function initTestimonials(root) {
    const section = root.querySelector('.ivalo-ed__testimonials');
    if (!section || section.dataset.devuiTestimonialsReady === 'true') return;

    const track = section.querySelector('.ivalo-ed__testimonial-track');
    const head = section.querySelector('.ivalo-ed__center-head');
    if (!track || !head) return;

    section.dataset.devuiTestimonialsReady = 'true';

    if (!head.querySelector('.devui-testimonial-kicker')) {
      const stars = document.createElement('div');
      stars.className = 'devui-testimonial-kicker';
      stars.setAttribute('aria-hidden', 'true');
      stars.textContent = '★★★★★';
      head.prepend(stars);
    }

    section.querySelectorAll('.ivalo-ed__quote').forEach((quote) => {
      const name = quote.querySelector('span');
      if (name) name.textContent = name.textContent.replace(/^[—–-]\s*/, '').trim();

      if (!quote.querySelector('.devui-review-stars')) {
        const stars = document.createElement('div');
        stars.className = 'devui-review-stars';
        stars.setAttribute('aria-hidden', 'true');
        stars.textContent = '★★★★★';
        quote.appendChild(stars);
      }
    });

    const nav = document.createElement('div');
    nav.className = 'devui-testimonial-nav';
    nav.setAttribute('aria-label', 'Testimonial navigation');
    nav.innerHTML = `
      <button type="button" data-devui-testimonial-prev aria-label="Previous testimonials">‹</button>
      <button type="button" data-devui-testimonial-next aria-label="Next testimonials">›</button>
    `;
    section.appendChild(nav);

    const scrollAmount = () => {
      const card = track.querySelector('.ivalo-ed__testimonial');
      if (!card) return Math.max(280, track.clientWidth * 0.8);
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };

    nav.querySelector('[data-devui-testimonial-prev]')?.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    nav.querySelector('[data-devui-testimonial-next]')?.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  }

  function initHomepageEnhancements(scope = document) {
    const roots = scope.querySelectorAll?.('#MainContent[data-template="index"] .ivalo-ed') || [];
    roots.forEach((root) => {
      initHotspotShowcase(root);
      initTestimonials(root);
    });
  }

  function init() {
    fixHeaderAccountIcons();
    initHomepageEnhancements();

    const headerGroup = document.querySelector('#header-group');
    if (headerGroup && 'MutationObserver' in window) {
      let scheduled = false;
      const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          fixHeaderAccountIcons();
        });
      });
      observer.observe(headerGroup, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    fixHeaderAccountIcons(document);
    initHomepageEnhancements(document);
  });
})();
